import React from "react";
import { useNavigate } from "react-router-dom";
import { usePlan } from "../../contexts/PlanContext";
import { Card, CardContent } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Lock, ArrowRight, Crown } from "lucide-react";

export default function UpgradePage() {
    const navigate = useNavigate();
    const { planData } = usePlan();

    return (
        <div className="flex items-center justify-center min-h-[70vh]" data-testid="upgrade-page">
            <Card className="max-w-md w-full text-center">
                <CardContent className="pt-10 pb-10 space-y-5">
                    <div className="mx-auto w-16 h-16 rounded-full bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center">
                        <Lock className="w-8 h-8 text-amber-600" />
                    </div>
                    <h2 className="text-xl font-bold text-foreground">
                        Fonctionnalite non disponible
                    </h2>
                    <p className="text-muted-foreground text-sm">
                        Cette fonctionnalite n'est pas incluse dans votre plan <strong>{planData?.plan_name || "Basic"}</strong>.
                        Passez a un plan superieur pour y acceder.
                    </p>
                    <div className="flex flex-col gap-2 pt-2">
                        <Button onClick={() => navigate("/settings/subscription")} data-testid="upgrade-btn">
                            <Crown className="w-4 h-4 mr-2" />
                            Voir les plans
                        </Button>
                        <Button variant="ghost" onClick={() => navigate(-1)} data-testid="go-back-btn">
                            Retour
                        </Button>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
